import React, { useState } from 'react';
import { ComplianceCompanyConfig } from '@/constants/compliance-companies';
import { ComplianceLanding } from './ComplianceLanding';
import { ComplianceOverview } from './ComplianceOverview';
import { ComplianceCall } from './ComplianceCall';
import { ComplianceFeedback } from './ComplianceFeedback';

export type ComplianceViewState = 'landing' | 'overview' | 'call' | 'feedback';

interface ComplianceDemoProps {
  config: ComplianceCompanyConfig;
}

export const ComplianceDemo: React.FC<ComplianceDemoProps> = ({ config }) => {
  const [currentView, setCurrentView] = useState<ComplianceViewState>('landing');
  const [callDuration, setCallDuration] = useState<number>(0);
  const [callTranscript, setCallTranscript] = useState<Array<{
    source: 'ai' | 'user';
    message: string;
    timestamp: Date;
  }>>([]);

  const handleStartTraining = () => {
    setCurrentView('overview');
  };

  const handleBeginCall = () => {
    setCurrentView('call');
  };

  const handleEndCall = (duration: number, transcript?: Array<{
    source: 'ai' | 'user';
    message: string;
    timestamp: Date;
  }>) => {
    setCallDuration(duration);
    if (transcript) {
      setCallTranscript(transcript);
    }
    setCurrentView('feedback');
  };

  const handleStartNewSession = () => {
    setCallTranscript([]);
    setCallDuration(0);
    setCurrentView('overview');
  };

  const handleBackToLanding = () => {
    setCurrentView('landing');
  };

  switch (currentView) {
    case 'landing':
      return <ComplianceLanding config={config} onStartTraining={handleStartTraining} />;
    case 'overview':
      return <ComplianceOverview config={config} onBeginCall={handleBeginCall} onBack={handleBackToLanding} />;
    case 'call':
      return <ComplianceCall config={config} onEndCall={handleEndCall} />;
    case 'feedback':
      return (
        <ComplianceFeedback
          config={config}
          callDuration={callDuration}
          transcript={callTranscript}
          onStartNewSession={handleStartNewSession}
          onBackToLanding={handleBackToLanding}
        />
      );
    default:
      return <ComplianceLanding config={config} onStartTraining={handleStartTraining} />;
  }
};